import React from 'react'
import styled from 'styled-components'
import StyledScreen from './StyledScreen'
import screensaver from '../assets/screensaver.jpg'

const StyledEmptyPage = StyledScreen.extend`
`
const Screensaver = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background-image: url('${screensaver}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  /* @media screen and (orientation:portrait) {
    width: 90vh;
  } */
`

export default function EmptyPage() {
  return (
    <StyledEmptyPage>
      <Screensaver />
    </StyledEmptyPage>
  )
}



// WEBPACK FOOTER //
// ./src/components/EmptyPage.js